<template>
  <div class="areaScreenStyle" style="position: relative;">
    <span style="float: left;position: absolute;left: 0.5%;top: 0%;color: #0084ff;font-size: 44px;cursor:pointer;">
      <i class="fa fa-home" aria-hidden="true" @click="toHome"></i>
    </span>
    <span style="float: right;position: absolute;right: 0.5%;top: 0%;color: #0084ff;font-size: 44px;cursor:pointer;">
      <i class="fa fa-arrows-alt" aria-hidden="true" @click="fullPage"></i>
    </span>
    <div style="text-align:justify;text-justify:distribute-all-lines;text-align-last:justify;padding: 0 50px 250px;">{{ titleName }}</div>
    <div>待&nbsp;&nbsp;&nbsp;&nbsp;验&nbsp;&nbsp;&nbsp;&nbsp;区</div>
  </div>
</template>

<script>
  import moment from "moment";
  import screenFull from 'screenfull';
  import { BaseModule } from "@/store/modules/base/base";
  import Storage from "@/util/storage";

  export default {
    // 待验收区单面屏
    name: 'acceptanceAreaScreen',
    components: {},
    data () {
      return {
        tokenInfo: Storage.getToken(),
        moment,
        pages: 0,
        number: 1,
        data: [],
        total: 0,
        current: 1,
        size: 20,
        titleName: '安医绩溪院区',
      }
    },
    mounted () {
      this.getData();
      this.titleName = this.$route.query.orgName ? this.$route.query.orgName : this.titleName;
      // this.titleName = `安医${this.titleName.replace((this.titleName.slice(0,12)), '')}`; // 后端接口已返回简称不需要截取
      // this.titleName = `安医${this.titleName.substring(this.titleName.length - 4)}`;
    },
    methods: {
      getData () {
        BaseModule.willAcceptPage({
          current: this.current,
          size: this.size,
          orgId: this.$route.query.orgId,
          auth: false,
        })
                .then((res) => {
                  if (res.code === 200) {
                    this.data = res.data.records;
                    this.total = res.data.total;
                    this.pages = res.data.pages;
                  } else {
                    this.$message.error(res.message);
                  }
                })
                .catch((err) => {
                  console.log(err, "err");
                });
      },
      fullPage () {
        // 判断是否支持
        if (!screenFull.isEnabled) {
          this.$message.error("不支持全屏");
          return false;
        }
        screenFull.toggle();
      },
      toHome () {
        this.$router.push({ path: '/' })
      }
    },
  }
</script>

<style lang="less" scoped>
  .areaScreenStyle {
    background-color: #0084ff !important;
    padding: 0px;
    width: 2000px;
    height: 1080px;
    text-align:center;
    color: #fff;
    font-size: 140px;

    display: table-cell;
    vertical-align:middle
  }
  // /deep/ html,
  // .container {
  //   background-color: #58a7f8 !important;
  // }
  /deep/ .ant-table table {
    th {
      color: #fff;
      background-color: #0084ff;
      border: none;
    }
    tr {
      border: none;
    }
    td {
      border:0px;
      text-align:center;
    }
    background-color: #0084ff;
    font-size: 28px;
    border: 0;
    color: #fff;
  }
  // 无数据显示的背景色
  /deep/.ant-table-small > .ant-table-content .ant-table-placeholder, .ant-table-small > .ant-table-content .ant-table-row:last-child td {
    background-color: #0084ff;
  }
  /deep/ .ant-table-small.ant-table-bordered .ant-table-placeholder {
    background-color: #e5f7ff;
  }
  /deep/ .ant-table-small > .ant-table-content > .ant-table-body {
    margin: 0;
  }
</style>
